/**
 * Function to map button type to its corresponding CSS class
 * @param {string} buttonType - The type of the button
 * @returns {string} The CSS class corresponding to the button type
 */
const mapButtonType = (buttonType) => {
    let btnTypeClass;

    // Mapping button type to its corresponding CSS class
    switch (buttonType) {
        case "Primary Large":
            btnTypeClass = "btn-primary-large";
            break;
        case "Primary Large Invert 1":
            btnTypeClass = "btn-primary-large-invert-1";
            break;
        case "Primary Large Invert 2":
            btnTypeClass = "btn-primary-large-invert-2";
            break;
        case "Primary Medium Invert 2":
            btnTypeClass = "btn-primary-medium-invert-2";
            break;
        case "Primary Small":
            btnTypeClass = "btn-primary-small";
            break;
        case "Primary Small Invert 1":
            btnTypeClass = "btn-primary-small-invert-1";
            break;
        case "Primary Small Invert 2":
            btnTypeClass = "btn-primary-small-invert-2";
            break;
        case "Secondary Large":
            btnTypeClass = "btn-secondary-large";
            break;
        case "Secondary Large Invert 1":
            btnTypeClass = "btn-secondary-large-invert-1";
            break;
        case "Secondary Small":
            btnTypeClass = "btn-secondary-small";
            break;
        case "Secondary Small Invert 1":
            btnTypeClass = "btn-secondary-small-invert-1";
            break;
        case "Secondary With Play Icon":
            btnTypeClass = "btn-secondary-play-icon-white";
            break;
        case "Secondary Invert 1 With Play Icon":
            btnTypeClass = "btn-secondary-invert-1-with-play-icon";
            break;
        case "Secondary Large With Play Icon":
            btnTypeClass = "btn-secondary-large-with-play-icon";
            break;
        case "Grey Link":
            btnTypeClass = "grey-link";
            break;
        case "Green Link":
            btnTypeClass = "green-link";
            break;
        case "White Link":
            btnTypeClass = "white-link";
            break;
        default:
            btnTypeClass = "";
            break;
    }

    return btnTypeClass;
};

export default mapButtonType;
